var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{directives:[{name:"intersect",rawName:"v-intersect",value:({
    handler: _vm.onIntersect,
    options: {
      threshold: 1.0,
    },
  }),expression:"{\n    handler: onIntersect,\n    options: {\n      threshold: 1.0,\n    },\n  }"}],attrs:{"flat":"","tile":""}},[_c('span',[_vm._v(_vm._s(_vm.item.name))]),_c('v-progress-linear',{attrs:{"value":_vm.intersectingProgress,"color":_vm.color,"height":"25","indeterminate":_vm.isIntersecting}},[_c('span',{staticClass:"progress__label"},[_vm._v(_vm._s(_vm.item.years)+" yr.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }